import { fetchAllUsersWeeklyHoursMap, isDateInRange } from "./utils";

export const generateProjectCostCSVData = async (
  startDate,
  endDate,
  selectedProject
) => {
  const timesheetData = await fetchAllUsersWeeklyHoursMap(startDate, endDate);

  if (!timesheetData || timesheetData.length === 0) {
    return "";
  }

  // Create a map to accumulate total cost per project.
  const projectCostMap = {};

  timesheetData.forEach((entry) => {
    // Only include entries within the selected date range.
    if (!isDateInRange(entry.timeEntryDate, startDate, endDate)) return;

    // If a project filter is applied, only include matching entries.
    if (
      selectedProject &&
      selectedProject.value &&
      entry.flowId !== selectedProject.value
    ) {
      return;
    }

    // Use "flowId" as the Project ID.
    const projectId = entry.flowId;
    // Use projectName from the entry (or fallback if missing).
    const projectName = entry.projectName || "Unknown Project";
    // Calculate cost as hours (billableHours) multiplied by cost rate.
    const hours = parseFloat(entry.billableHours) || 0;
    const costRate = parseFloat(entry.cost) || 0;
    const entryCost = hours * costRate;

    if (projectCostMap[projectId]) {
      projectCostMap[projectId].totalCost += entryCost;
    } else {
      projectCostMap[projectId] = {
        projectName,
        totalCost: entryCost,
      };
    }
  });

  // Build CSV rows: header + one row per project.
  const header = "Project ID,Project Name,Total Cost";
  const rows = [header];

  Object.keys(projectCostMap).forEach((projectId) => {
    const { projectName, totalCost } = projectCostMap[projectId];
    rows.push(`${projectId},"${projectName}",$${totalCost.toFixed(2)}`);
  });

  return rows.join("\n");
};

export const downloadProjectCostCSV = async (
  startDate,
  endDate,
  selectedProject
) => {
  const csvContent = await generateProjectCostCSVData(
    startDate,
    endDate,
    selectedProject
  );

  if (!csvContent) {
    alert("No project cost data available to download.");
    return;
  }

  // Create a Blob from the CSV string and trigger a download.
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", "project-cost.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
